import script from "./PedidoVendaAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoVendaAdministrar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__